import i18next from "i18next";
import { z } from "zod";

export const proposalLineSchema = z.object({
  gross_price: z.coerce.number().min(0.001),
  measure_unit: z.string(),
  position: z.coerce.number().min(0),
  quantity: z.coerce
    .number()
    .int(i18next.t("newProposal.messages.quantityMustBeWholeNumber"))
    .min(1),
  short_text: z.string(),
});

export type ProposalLineSchema = z.infer<typeof proposalLineSchema>;
